import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { apiGet } from '../api/client';

interface VipStatus {
  configured: boolean;
  current_level: number | null;
  next_level: number | null;
  deposit_total_minor: number;
  levels: Array<{ level: number; name: string; min_deposit_total_minor: number; benefits: string }>;
  message: string | null;
}

export function VipPage() {
  const { t } = useTranslation(['common']);
  const [vip, setVip] = useState<VipStatus | null>(null);

  useEffect(() => {
    void apiGet<VipStatus>('/api/v1/vip')
      .then(setVip)
      .catch(() => setVip(null));
  }, []);

  if (!vip || !vip.configured) {
    return (
      <div className="page">
        <h1>VIP</h1>
        <div className="state-card">
          <h3>{t('unavailableTitle')}</h3>
          <p>{t('vipUnavailable')}</p>
        </div>
      </div>
    );
  }

  return (
    <div className="page">
      <h1>VIP</h1>
      <p className="muted-note">
        Level: {vip.current_level ?? '—'} · Deposits total: {(vip.deposit_total_minor / 100).toFixed(2)} AZN
      </p>
      <div className="history-list">
        {vip.levels.map((lvl) => (
          <article key={lvl.level} className="history-row">
            <div>
              <strong>
                {lvl.level}. {lvl.name}
              </strong>
              <p>{lvl.benefits}</p>
            </div>
            <div>≥ {(lvl.min_deposit_total_minor / 100).toFixed(2)}</div>
          </article>
        ))}
      </div>
    </div>
  );
}
